(function() { window.GUID_6ff6fff1_ecb9_4cbd_b964_06354d43528f = { getGuid: function() { return "6ff6fff1-ecb9-4cbd-b964-06354d43528f"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class popupwizard_sportevent_fees_make_payment extends Controls.PopupWizardStep {
            constructor() {
                super(...arguments);
                this.NextStep = "payment-sent";
                this.paymentInProgress = false;
            }
            OnLoad() {
                let me = this;
                //$("#popupwizard-sportevent-fees-form-3").validate({
                //    ignore: ":hidden"
                //});
                me.$button = $("#button-make-payment").remove();
                $(".popupwizard-footer").find(".next").hide();
                $(".popupwizard-footer").children("div").append(me.$button);
                $("#creditcard-sporteventfee-payment").off('paymentRequest').on('paymentRequest', (event, options) => {
                    const description = $('#Payment_Description').val();
                    const price = parseInt($('#Payment_Total').val());
                    const currency = parseInt($('#Payment_Currency').val());
                    if (options) {
                        options.currency = currency; //'usd'
                        options.total = {
                            label: description,
                            amount: isNaN(price) ? 0 : price,
                        };
                    }
                });
                // Callback when a payment method is created.
                $("#creditcard-sporteventfee-payment").off('token').on('token', (event, data) => {
                    if (me.SetOutcome(data)) {
                        data.complete('success');
                    }
                    else {
                        data.complete('fail');
                    }
                });
                $("#button-make-payment").off('click').on('click', (e) => __awaiter(this, void 0, void 0, function* () {
                    e.preventDefault();
                    let me = this;
                    if (me.paymentInProgress)
                        return;
                    me.paymentInProgress = true;
                    CS.Helper.disableButton(me.$button);
                    let useCredit = $("#checkbox-usemycredit").val() == 'true';
                    var creditAvail = Number($("#CreditAvail").val());
                    let totalamount = Number($("#TotalFees").val());
                    //si le crédit peut tout payer, on a pas besoin de la carte
                    if (useCredit && creditAvail >= 0 && totalamount == 0) {
                        var $form = $('.popupwizard-content').find('form').last();
                        var action = $form.find("#Payment_Action").val();
                        var controller = $form.find("#Payment_ActionController").val();
                        if (action != undefined) {
                            CS.Ajax.Post(CS.Url.Action(action, controller), $form.serialize(), function (response) {
                                if (response.success) {
                                    $("#button-make-payment").remove();
                                    CS.DOM.$body.trigger("payment-done");
                                    me.Wizard.GoToNextStep();
                                }
                                else {
                                    const errorElement = $('#errorMessage');
                                    errorElement[0].innerText = response.message;
                                    errorElement.show();
                                    me.ScrollToElement(errorElement);
                                }
                                me.paymentInProgress = false;
                                CS.Helper.enableButton(me.$button);
                            });
                        }
                        //paywithCredit.
                    }
                    else {
                        CS.Lag('fees-payment-timer', 1000, () => __awaiter(this, void 0, void 0, function* () {
                            yield c_creditcard_sporteventfee_payment.MakePayment((cardInfoId) => {
                                var $form = $('.popupwizard-content').find('form').last();
                                var action = $form.find("#Payment_Action").val();
                                var controller = $form.find("#Payment_ActionController").val();
                                if (action != undefined) {
                                    CS.Ajax.Post(CS.Url.Action(action, controller), $form.serialize(), function (response) {
                                        if (response.success) {
                                            $("#button-make-payment").remove();
                                            CS.DOM.$body.trigger("payment-done");
                                            me.Wizard.GoToNextStep();
                                        }
                                        else {
                                            const errorElement = $('#errorMessage');
                                            errorElement[0].innerText = response.message;
                                            errorElement.show();
                                            me.ScrollToElement(errorElement);
                                        }
                                        me.paymentInProgress = false;
                                        CS.Helper.enableButton(me.$button);
                                    });
                                }
                            }, (result) => {
                                me.SetOutcome(result);
                            });
                        }));
                    }
                }));
                CS.Controls.CheckBox.Events.CheckboxValueChanged({
                    selector: "#checkbox-usemycredit",
                    callback: (checkbox, e) => {
                        if (checkbox.IsChecked) {
                            //mettre les montant a zéro
                            $("#ServiceFeeAmount").html("0");
                            var newAmount = Number($("#TotalFees").val());
                            var creditAvail = Number($("#CreditAvail").val());
                            if (creditAvail >= newAmount) {
                                $("#TotalAmount").html("0");
                                $("#TotalFees").val("0");
                                $("#creditcard-sporteventfee-payment").hide();
                                $("#SelectMethod").hide();
                                $("#creditcard-sporteventfee-payment").addClass("hidden");
                            }
                            else {
                                newAmount = newAmount - creditAvail;
                                $("#TotalAmount").html("$ " + newAmount.toFixed(2).toString());
                                $("#TotalFees").html(newAmount.toFixed(2).toString());
                                $("#TotalFees").val(newAmount);
                                $("#Payment_TotalAmount").html(newAmount.toFixed(2).toString());
                                $("#Payment_Total").val(newAmount * 100);
                            }
                        }
                        else {
                            //remettres les montant du hidden.
                            let serviceFees = $("#Payment_ServiceFee").val();
                            let totalamount = $("#Payment_TotalAmount").val();
                            let totalamountval = Number($("#Payment_TotalAmountVal").val());
                            $("#ServiceFeeAmount").html(serviceFees);
                            $("#TotalAmount").html(totalamount);
                            $("#TotalFees").html(totalamount);
                            $("#TotalFees").val(totalamountval);
                            $("#Payment_Total").val(totalamountval * 100);
                            $("#Payment_TotalAmount").html(totalamount);
                            $("#creditcard-sporteventfee-payment").show();
                            $("#SelectMethod").show();
                            $("#creditcard-sporteventfee-payment").removeClass("hidden");
                        }
                    }
                });
            }
            OnCheckIfCanContinue() {
                return false;
            }
            OnPrevious() {
                $("#button-make-payment").remove();
                $(".popupwizard-footer").find(".next").show();
            }
            SetOutcome(result) {
                var _a, _b;
                let me = this;
                if (result.cardInfoId) {
                    return true;
                }
                else if (result.token) {
                    //var $form = $('#form-sporteventfees-payment');
                    //var action = $form.attr('action');
                    //le form original se fait remplacer dans l'overlay...
                    var $form = $('.popupwizard-content').find('form').last();
                    var action = $form.find("#Payment_Action").val();
                    var controller = $form.find("#Payment_ActionController").val();
                    $form.find("#Payment_Token").val(result.token);
                    if (action != undefined) {
                        CS.Ajax.Post(CS.Url.Action(action, controller), $form.serialize(), function (response) {
                            if (response.success) {
                                $("#button-make-payment").remove();
                                CS.DOM.$body.trigger("payment-done");
                                me.Wizard.GoToNextStep();
                            }
                            else {
                                const errorElement = $('#errorMessage');
                                errorElement[0].innerText = response.message;
                                errorElement.show();
                                me.ScrollToElement(errorElement);
                                if (response.newCSToken) {
                                    $form.find('#CSToken').val(response.newCSToken);
                                }
                            }
                            me.paymentInProgress = false;
                            CS.Helper.enableButton(me.$button);
                        });
                    }
                    return true;
                }
                else if (result.error) {
                    const errorElement = $('#errorMessage');
                    errorElement[0].innerText = (_b = (_a = result.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : result.error;
                    errorElement.show();
                    me.ScrollToElement(errorElement);
                    me.paymentInProgress = false;
                    CS.Helper.enableButton(me.$button);
                }
                return false;
            }
            ScrollToElement(elemToScroll) {
                let me = this;
                if (elemToScroll.length > 0) {
                    let y = elemToScroll.offset().top;
                    let content = $('.popupwizard-content');
                    content.scrollTop(y);
                }
            }
        }
        Controls.popupwizard_sportevent_fees_make_payment = popupwizard_sportevent_fees_make_payment;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=make-payment.js.map
